/*
  MTi USA PWA — first-open coach-mark tour.
  Loaded only when the "Enable PWA" theme setting is on (see pwa-head.liquid),
  after pwa.js so the html.pwa-standalone class is already set.

  Runs once, on the first open of the installed app, on the home screen. It
  dims the app and spotlights each part in turn (search, the four tabs) with a
  short explanation, then a sign-in nudge. Fully skippable; never shown again
  after it's completed or skipped (localStorage flag).

  QA / re-view overrides (query string):
    ?pwa-tour=1      force the tour to run now (ignores the "seen" flag)
    ?pwa-tour=reset  clear the "seen" flag so it runs again next home open
*/
(function () {
  'use strict';

  var DONE_KEY = 'mti-pwa-tour-done';

  function safeLS() {
    try { var s = window.localStorage; s.getItem('mti-tour-probe'); return s; } catch (e) { return null; }
  }
  var LS = safeLS();
  function lsGet(k) { try { return LS ? LS.getItem(k) : null; } catch (e) { return null; } }
  function lsSet(k, v) { try { if (LS) LS.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { if (LS) LS.removeItem(k); } catch (e) {} }

  var param = (location.search.match(/[?&]pwa-tour=([^&]+)/) || [])[1] || '';
  if (param === 'reset') { lsDel(DONE_KEY); }
  var forced = param === '1';

  var docEl = document.documentElement;
  var isStandalone = docEl.classList.contains('pwa-standalone');
  var isHome = docEl.classList.contains('pwa-tmpl-index');

  // Only inside the installed app, only on the home screen, only once.
  if (!forced) {
    if (!isStandalone || !isHome) return;
    if (lsGet(DONE_KEY)) return;
  }

  var steps = [
    { center: true, ey: 'Welcome', t: 'MTi USA, on your phone',
      b: 'Reorder in a couple taps, browse by category, and get same-day gear from Stanton, KY. Here’s a 20-second tour.' },
    { sel: '.mti-v2-search-trigger', ey: 'Search', t: 'Find anything fast',
      b: 'Tap here to search products, SKUs, or specs — results show as you type.' },
    { sel: '.pwa-bottom-nav__item[data-nav="home"]', ey: 'Home', t: 'Your starting point',
      b: 'Jump back into past orders, shop by category, and see best sellers.' },
    { sel: '.pwa-bottom-nav__item[data-nav="shop"]', ey: 'Shop', t: 'Browse the catalog',
      b: 'All 400+ products, organized by category and mine type.' },
    { sel: '.pwa-bottom-nav__item[data-nav="account"]', ey: 'Account', t: 'Orders & reordering',
      b: 'Your past orders and one-tap “Buy again” live here.' },
    { sel: '.pwa-bottom-nav__item[data-nav="cart"]', ey: 'Cart', t: 'Check out when ready',
      b: 'Review your order and check out securely.' },
    { center: true, ey: 'One thing', t: 'Sign in to see your price',
      b: 'Prices show once you sign in or create an account. New here? Browse all you like — no account needed to look around.',
      fin: true }
  ];

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function injectStyle() {
    if (document.getElementById('mtour-style')) return;
    var s = document.createElement('style');
    s.id = 'mtour-style';
    s.textContent = [
      '#mtour{position:fixed;inset:0;z-index:10000;font-family:"Myriad Pro",system-ui,sans-serif}',
      '.mtour-catch{position:fixed;inset:0;z-index:1}',
      '.mtour-dim{position:fixed;inset:0;background:rgba(15,18,10,.72);z-index:1;opacity:0;transition:opacity .2s}',
      '.mtour-dim.on{opacity:1}',
      '.mtour-spot{position:fixed;z-index:2;border-radius:14px;box-shadow:0 0 0 9999px rgba(15,18,10,.72);border:2px solid #76bd22;pointer-events:none;' + (reduce ? '' : 'transition:all .25s ease') + '}',
      '.mtour-pop{position:fixed;z-index:3;width:270px;max-width:calc(100vw - 32px);background:#fff;border-radius:16px;padding:16px 16px 14px;box-shadow:0 12px 40px rgba(0,0,0,.35)}',
      '.mtour-pop__ey{font-weight:700;text-transform:uppercase;letter-spacing:.12em;font-size:10.5px;color:#5a9219}',
      '.mtour-pop__t{font-family:"Avenir Black","Avenir Next",Arial,sans-serif;font-weight:900;text-transform:uppercase;font-size:18px;color:#1a1b1f;margin:5px 0 6px;line-height:1.05}',
      '.mtour-pop__b{font-size:13.5px;line-height:1.4;color:#444}',
      '.mtour-foot{display:flex;align-items:center;justify-content:space-between;margin-top:14px}',
      '.mtour-dots{display:flex;gap:5px}',
      '.mtour-dot{width:6px;height:6px;border-radius:50%;background:#d7d7d7}',
      '.mtour-dot.on{background:#76bd22;width:16px;border-radius:99px}',
      '.mtour-actions{display:flex;gap:8px;align-items:center}',
      '.mtour-skip{background:none;border:none;color:#8a8a8a;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit}',
      '.mtour-next{background:#76bd22;color:#fff;border:none;border-radius:999px;padding:9px 18px;font-weight:800;font-size:13.5px;cursor:pointer;font-family:inherit}',
      '.mtour-ghost{background:#1a1b1f}',
      '.mtour-center{left:50%;top:50%;transform:translate(-50%,-50%);width:300px;text-align:center}',
      '.mtour-center .mtour-foot{justify-content:center;flex-direction:column;gap:10px}',
      '.mtour-center .mtour-actions{width:100%;justify-content:center}'
    ].join('');
    document.head.appendChild(s);
  }

  function run() {
    injectStyle();
    var root = document.createElement('div');
    root.id = 'mtour';
    root.innerHTML =
      '<div class="mtour-catch"></div><div class="mtour-dim"></div>' +
      '<div class="mtour-spot" style="display:none"></div><div class="mtour-pop"></div>';
    document.body.appendChild(root);
    var dim = root.querySelector('.mtour-dim');
    var spot = root.querySelector('.mtour-spot');
    var pop = root.querySelector('.mtour-pop');

    function done() {
      root.remove();
      lsSet(DONE_KEY, '1');
    }

    function esc(html) { return html; }

    function render(n) {
      var s = steps[n];
      var dots = steps.map(function (_, k) {
        return '<span class="mtour-dot' + (k === n ? ' on' : '') + '"></span>';
      }).join('');
      var lastBtn = s.fin ? 'Got it' : (n === steps.length - 1 ? 'Done' : 'Next');
      var signin = s.fin ? '<button class="mtour-next mtour-ghost" data-signin>Sign in</button>' : '';

      if (s.center) {
        spot.style.display = 'none';
        dim.classList.add('on');
        pop.className = 'mtour-pop mtour-center';
        pop.innerHTML =
          '<div class="mtour-pop__ey">' + s.ey + '</div>' +
          '<div class="mtour-pop__t">' + s.t + '</div>' +
          '<div class="mtour-pop__b">' + s.b + '</div>' +
          '<div class="mtour-foot"><div class="mtour-dots">' + dots + '</div>' +
          '<div class="mtour-actions">' + (n === 0 ? '<button class="mtour-skip" data-skip>Skip</button>' : '') +
          signin + '<button class="mtour-next" data-next>' + (n === 0 ? 'Start tour' : lastBtn) + '</button></div></div>';
      } else {
        var el = document.querySelector(s.sel);
        if (!el) { return render(n + 1 < steps.length ? n + 1 : n); }
        dim.classList.remove('on');
        var r = el.getBoundingClientRect();
        var pad = 8;
        spot.style.display = 'block';
        spot.style.left = (r.left - pad) + 'px';
        spot.style.top = (r.top - pad) + 'px';
        spot.style.width = (r.width + pad * 2) + 'px';
        spot.style.height = (r.height + pad * 2) + 'px';
        spot.style.borderRadius = (r.height > 60 ? 14 : 99) + 'px';
        pop.className = 'mtour-pop';
        pop.innerHTML =
          '<div class="mtour-pop__ey">' + s.ey + '</div>' +
          '<div class="mtour-pop__t">' + s.t + '</div>' +
          '<div class="mtour-pop__b">' + s.b + '</div>' +
          '<div class="mtour-foot"><div class="mtour-dots">' + dots + '</div>' +
          '<div class="mtour-actions"><button class="mtour-skip" data-skip>Skip</button>' +
          '<button class="mtour-next" data-next>' + lastBtn + '</button></div></div>';
        var below = r.top < window.innerHeight * 0.5;
        pop.style.left = Math.min(Math.max(12, r.left + r.width / 2 - 135), window.innerWidth - 282) + 'px';
        pop.style.top = below ? (r.bottom + 14) + 'px' : '';
        pop.style.bottom = below ? '' : (window.innerHeight - r.top + 14) + 'px';
      }

      pop.querySelector('[data-next]').onclick = function () { n + 1 < steps.length ? render(n + 1) : done(); };
      var sk = pop.querySelector('[data-skip]'); if (sk) sk.onclick = done;
      var si = pop.querySelector('[data-signin]');
      if (si) si.onclick = function () { done(); window.location.href = '/pages/registration-form'; };
    }

    render(0);
  }

  function start() {
    // Let layout settle so the fixed bottom nav is in its final position.
    if (document.querySelector('.pwa-bottom-nav__item')) {
      setTimeout(run, reduce ? 0 : 350);
    } else {
      // Bottom nav not rendered (setting off) — nothing to tour.
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
